<template>
  <span>
    <span v-if="!button">
      <a :id="'edit' + data.id" href="#" @click.prevent="$bvModal.show(id)"><i class="pr-1 fa fa-lg fa-edit"></i></a>
      <b-tooltip :target="'edit' + data.id" noninteractive>Editar</b-tooltip>
    </span>
    <span v-if="button">
      <b-button variant="link" @click.prevent="$bvModal.show(id)" size="sm">Crear programa</b-button>
    </span>
    <b-modal
      :id="id"
      size="sm"
      :title="title"
      ok-only
      @show="onShow"
      @hide="onHide"
      @ok="handleOk"
      :ok-disabled="loading || $v.$invalid"
    >
      market: {{ market }} <br />
      week: {{ week }} <br />
      <b-form>
        <b-form-group label="Status" label-for="status">
          <b-form-select
            id="status"
            v-model="$v.form.status.$model"
            :state="$v.form.status.$dirty ? !$v.form.status.$error : null"
            :options="['vigente', 'cancelado', 'terminado']"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group label="Exportadora" label-for="client_customer">
          <b-form-select
            id="client_customer"
            v-model="$v.form.client_customer.$model"
            :state="$v.form.client_customer.$dirty ? !$v.form.client_customer.$error : null"
            :options="client_customers"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group label="Formato" label-for="container">
          <b-form-select
            id="container"
            value-field="value.id"
            text-field="text"
            v-model="$v.container.$model"
            :state="$v.container.$dirty ? !$v.container.$error : null"
            :options="containers"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group label="Recibidor" label-for="consignee">
          <b-form-select id="consignee" v-model="consignee" :options="consignees"> </b-form-select>
        </b-form-group>
        <b-form-group label="Kilos" label-for="kilos">
          <b-form-input
            id="kilos"
            type="number"
            v-model="$v.form.kilograms.$model"
            :state="$v.form.kilograms.$dirty ? !$v.form.kilograms.$error : null"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <p class="my-1">{{ subplan }}</p>
    </b-modal>
  </span>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import _ from "lodash";

export default {
  name: "CreatePlan",
  data() {
    return {
      loading: false,
      newPlan: false,
      form: {
        client_customer: "",
        status: "vigente",
        market: "",
        week: "",
        kilograms: 0,
        subplan: ""
      },
      consignee: "",
      container: "",
      consignees: [],
      containers: [],
      client_customers: []
    };
  },
  validations: {
    form: {
      client_customer: {
        required
      },
      status: {
        required
      },
      market: {
        required
      },
      week: {
        required
      },
      kilograms: {
        required
      }
    },
    container: {
      required
    }
  },
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    data: {
      type: Object,
      default: () => {}
    },
    button: {
      type: Boolean,
      default: false
    },
    market: {
      type: Number
    },
    week: {
      type: String
    },
    marketAllowedContainers: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    allowedContainers() {
      // Array to string
      const marketAllowedContainers = this.marketAllowedContainers.join(",");
      return marketAllowedContainers;
    },
    subplan() {
      const container = this.containers.find((container) => container.value.id == this.container);
      if (container) {
        if (this.consignee) {
          const consigneeName = this.consignees.find((c) => c.value === this.consignee).text;
          return `${consigneeName}: ${container.text}`;
        } else {
          return `${container.text}`;
        }
      } else {
        return "";
      }
    }
  },
  methods: {
    onShow() {
      this.form.market = this.market;
      this.form.week = this.week;
      this.getConsignees();
      this.getContainers();
      this.getClientCustomers();
      if (this.newPlan) {
        this.form.kilograms = 0;
      } else {
        this.form.kilograms = this.data.kilograms;
        this.form.client_customer = this.data.client_customer;
        this.form.status = this.data.status;
        this.container = this.data.container;
        this.consignee = this.data.consignee;
      }
    },
    resetForm() {
      this.form = {
        market: "",
        week: "",
        client_customer: "",
        kilograms: 0,
        subplan: ""
      };
      this.consignee = "";
      this.container = "";
      this.$v.form.$reset;
      this.$v.container.$reset;
    },
    onHide() {
      this.resetForm();
    },
    // Get containers from /api/v1/container/name_list/
    async getContainers() {
      try {
        const response = await this.$axios.get(
          "/api/v1/container/?no_page&allowed_containers=" + this.allowedContainers
        );
        this.containers = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Get consignee lest from api/comex/companyform/get_select_company/?client=4
    async getConsignees() {
      try {
        const response = await this.$axios.get(
          "/api/comex/companyform/get_select_company/?client=" + this.$store.state.user.ID_CLIENTE
        );
        this.consignees = response.data.consignee_company_list;
        this.consignees.unshift({ text: null, value: null });
      } catch (error) {
        console.log(error);
      }
    },
    // Get client customers from /production/get_customers/
    async getClientCustomers() {
      try {
        const response = await this.$axios.get("/production/get_customers/");
        this.client_customers = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    handleOk() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.savePlan();
      }
    },
    async savePlan() {
      this.loading = true;
      try {
        const payload = {
          market: this.form.market,
          week: this.form.week,
          client_customer: this.form.client_customer,
          status: this.form.status,
          subplan: this.subplan,
          container: this.container,
          consignee: this.consignee,
          kilograms: this.form.kilograms
        };
        if (this.newPlan) {
          await this.$axios.post("/api/comex/plan/", payload);
        } else {
          await this.$axios.put("/api/comex/plan/" + this.data.id + "/", payload);
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      this.$bvModal.hide(this.id);
      this.$emit("refresh", true);
    }
  },
  mounted() {
    this.newPlan = _.isEmpty(this.data);
  }
};
</script>

<style></style>
